import { http } from '@/http';

/**
 * Codes POST /v2/onboarding/{ulid}/abandon answers with 409. Each one means
 * the process must be resumed instead of replaced.
 */
export const ABANDON_CONFLICT_CODES = [
	'ALREADY_PAID',
	'UNDER_REVIEW',
	'NO_ACTIVE_CERTIFICATE',
];

export const abandonOnboarding = (ulid: string) =>
	http.post<Record<string, unknown>>(
		`v2/onboarding/${encodeURIComponent(ulid)}/abandon`,
		null,
	);
